import React, { useEffect, useRef, useState } from "react";
import styles from "../mobilesignup2style.module.css";
import { Button, CircularProgress, TextField } from "@mui/material";
import { postFetch } from "../../../fetch/fetch";
import { set } from "lodash";
import { IonToast } from "@ionic/react";


const GetCertNumber: React.FC<any> = (props) => {

    const [disabled, setDisabled] = useState(true);
    const inputRef = useRef<HTMLInputElement>(null);
    const [loading, setLoading] = useState(false);

    const [resendLoading, setResendLoading] = useState(false);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    useEffect(() => {

        //인증번호가 6자리인지 확인
        const cert = props.certNumber ? props.certNumber.replace(/\D/g, '') : '';

        if (cert.length === 6) {
            setDisabled(false);
            //blur 처리
            if (inputRef && inputRef.current) {
                inputRef.current.blur();
            }

            submit();

        } else {
            setDisabled(true);
        }

    }, [props.certNumber]);

    const controlChange = (cert: string) => {

        if (!props.setCertNumber) {
            return;
        }

        props.setCertNumber(cert);

    }

    //처음에 focus 처리
    useEffect(() => {
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef.current]);

    const sendCert = async () => {

        try {

            setResendLoading(true);

            //await 로 변경
            const response = await fetch("https://peetsunbae.com/signup/cert", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    phoneNumber: props.phoneNumber
                })
            });

            const body = await response.json();

            console.log(body);

            alert(body.message);

            setResendLoading(false);

            if (body.message === "success") {
                return true;
            }

        } catch (e) {
            new Error("휴대폰 인증번호 전송에 실패했습니다.");
        }

    }


    const submit = async () => {

        try {

            setLoading(true);

            const result = await checkCert();

            if (!result) {
                setLoading(false);
                setToastMessage("😔 인증번호가 올바르지 않습니다.");
                setShowToast(true);
                //다시 Focus 처리
                if (inputRef && inputRef.current) {
                    inputRef.current.focus();
                }
                return;
            }

            setLoading(false);

            //다음 페이지로 이동
            if (props.setPage) {
                props.setPage(4);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const checkCert = async () => {

        try {

            console.log("인증번호 확인 시도", props.phoneNumber, props.certNumber);

            const result: any = await postFetch("/signup/checkcert", {
                phoneNumber: props.phoneNumber,
                certNumber: props.certNumber
            });

            console.log(result);

            if (result.message === "success") {

                if(result.hasDeactivatedAccount){
                    props.setHasDeactivatedAccount(true);
                    props.setName(result.name);
                }

                return true;
            } else {
                return false;
            }

        } catch (e) {
            console.log(e);
            new Error("인증번호 확인에 실패했습니다.");
        }

    }



    return (
        <div className={styles.mainContainer} style={{
            height: props.bodyHeight ? `${props.bodyHeight}px` : "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: props.pc ? "" : "space-between",
            // paddingBottom: "39px",
            paddingBottom : props.pc ? "" : "max(var(--safe-area-inset-bottom), 39px)",
        }}>
            <div style={{
                width: "100%",
                marginBottom : props.pc ? "30px" : "0px"
            }}>
                <div style={{
                    paddingTop: "28px",
                    color: "#202632",
                    fontFamily: "Apple_B",
                    fontSize: "24px",
                    lineHeight: "32px",
                    letterSpacing: "-2%",
                }}>
                    문자로 전송된<br />인증번호 6자리를 입력해주세요
                </div>
                <div style={{
                    marginTop: "40px"
                }}>
                    <div>
                        <TextField
                            variant="standard"
                            label="인증번호"
                            fullWidth
                            type="tel"
                            sx={{
                                "& .MuiInput-underline::before": {
                                    borderBottom: "1px solid #d3d3d3"
                                },
                                "& .MuiInput-underline": {
                                    height: "40px"
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    fontFamily: "Apple_SB",
                                    color: "#d3d3d3"
                                },
                                "& .MuiInputBase-input": {
                                    fontFamily: "Apple_SB",
                                    color: "#202632",
                                    fontSize: "20px"
                                },
                            }}
                            value={props.certNumber ? props.certNumber : ""}
                            onChange={(e) => controlChange(e.target.value)}
                            inputRef={inputRef}
                            inputProps={{
                                autoComplete: "one-time-code",
                                inputMode: "numeric"
                            }}
                        />
                    </div>
                </div>
                <div style={{
                    marginTop: "25px",
                    display: "flex",
                    justifyContent: "center",
                }}>
                    <div>
                        {
                            !resendLoading ?
                                <span
                                    style={{
                                        color: "#202632",
                                        fontSize: "14px",
                                        fontFamily: "Apple_R",
                                        letterSpacing: "-0.5px",
                                        textDecoration: "underline",
                                        textUnderlineOffset: "2px",      // 👈 간격
                                        textDecorationThickness: "1px",  // 👈 두께
                                    }}
                                    onClick={() => sendCert()}
                                >
                                    인증번호 재전송
                                </span>
                                :
                                <span>
                                    <CircularProgress size={16}
                                    />
                                </span>
                        }
                    </div>
                </div>
            </div>
            <div>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#3d50b0",
                        height: "52px",
                        borderRadius: "13px",
                        fontWeight: 500,
                        fontFamily: "Apple_R",
                        boxShadow: "none !important",
                        '&.Mui-disabled': {
                            backgroundColor: '#C1d6f3',
                            color: "white"
                        },
                        "&:hover": {
                            backgroundColor: "#3d50b0",
                            boxShadow: "none",
                        },

                        "&:active": {
                            backgroundColor: "#3d50b0",
                        },

                        "&.Mui-focusVisible": {
                            backgroundColor: "#3d50b0",
                        }
                    }}
                    fullWidth
                    disabled={disabled || loading}
                    onClick={() => {
                        submit();
                    }}
                >
                    {
                        !loading ?
                            "확인"
                            :
                            <CircularProgress size={24} style={{ color: "white" }} />
                    }
                </Button>
            </div>

            <IonToast
                isOpen={showToast}
                onDidDismiss={() => { setShowToast(false); setToastMessage(""); }}
                message={toastMessage}
                duration={1500}
                position="top"
                color="danger"
            />
        </div>
    )
}

export default GetCertNumber;